import React from "react";
import I18n from "../../../i18n/";
import { ArrayUtil, DateUtil, isAlive } from "../../../util";
import ReportAction from "../../../actions/ReportAction";
import OrgUtil from "../../../util/organize";
import { StressGeneric } from "./index";

export default (props)=>{
	const { categoryInfo } = props;
	const { name, id } = categoryInfo;
	return <StressGeneric 
		typeKey={name}
		subHeader={name}
		fetchMain={(props)=>ReportAction.fetchStressCategory({...props, category:id})}
		// fetchSelect={(props)=>ReportAction.fetchStressCategorySelect({...props, category:id}).then(({summary})=>summary)}
		getAutoSelectItem={(items)=>items[0].id}
		mainSelectToFilterValue={(typeKey, item)=>{
			if(typeof item === "number"){
				return item;
			}else if(typeof item === "string"){
				return OrgUtil.getCategoryIdByName(name, item);
			}
			return item;
		}}
	/>;
};


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Stress/StressByCategory.js